import {Component, Input, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import {FilesService} from "../../services/files/files.service";
import * as AuthSelectors from "../../state/auth/auth.selector";
import {NgIf} from "@angular/common";

@Component({
  selector: 'base64-image',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './base64-image.component.html',
  styleUrl: './base64-image.component.scss'
})
export class Base64ImageComponent implements OnInit {
  b64String: string = ""

  @Input()
  borderRadiusRem: number = 1

  @Input()
  set base64String(pb64String) {
    this.b64String = pb64String
  }

  @Input()
  set fileId(pFileId) {
    this.fileService.getFile(pFileId).then(serverFile => {
      this.base64String = serverFile.fileData
    })
  }


  constructor(
      private store: Store,
      private fileService: FilesService
  ) {
  }

  async ngOnInit() {
  }
}
